import { Outlet } from 'react-router-dom';
import { NotAuthorised } from './require-permission';
import { tenantPagePermissions, useTenantPageSelection } from '@/pages/admin/shared';

export function RequireTenantAdministration() {
  const { access, has } = useTenantPageSelection();
  if (['loading', 'idle', 'switching'].includes(access.status)) return <p role="status">Loading tenant access…</p>;
  return tenantPagePermissions.some(has) ? <Outlet /> : <NotAuthorised />;
}
